import React, { useEffect, useState } from "react";
import { Row } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import {
  useLazyCategoryViewQuery,
  useCategoryCreateMutation,
  useCategoryUpdateMutation,
  useLazyCategoryCreateListQuery,
} from "../../redux/api/api";
import { saveLoader } from "../../redux/slice/loaderNoti";
import TopHeader from "../Dashoboard/TopHeader";

const HotelCategory = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const types = location?.state?.type;

  const [name, setName] = useState("");
  const [service_type, setService_type] = useState([]);
  const [image, setImage] = useState("");
  const [payment_type, setPayment_type] = useState("");
  const [cancelation_policy, setCancelation_policy] = useState("");
  const [days, setDays] = useState("");
  const [nameErr, setNameErr] = useState(false);
  const [service_typeErr, setService_typeErr] = useState(false);
  const [payment_typeErr, setPayment_typeErr] = useState(false);
  const [cancelation_policyErr, setCancelation_policyErr] = useState(false);
  const [imageErr, setImageErr] = useState(false);
  const [daysErr, setDaysErr] = useState(false);
  const [btn, setBtn] = useState(false);

  // RTK QUERY
  const [addApi] = useCategoryCreateMutation();
  const [editApi] = useCategoryUpdateMutation();
  const [viewApi] = useLazyCategoryViewQuery();
  const [categoryCreateApi] = useLazyCategoryCreateListQuery();

  const submitHandler = () => {
    if (
      name?.length == 0 ||
      (types !== "edit" && image?.length == 0) ||
      service_type?.length == 0
    ) {
      setNameErr(true);
      setService_typeErr(true);
      if (types !== "edit") {
        setImageErr(true);
      }
    } else {
      let formdata = new FormData();
      formdata.append("name", name);
      formdata.append("services", service_type?.toString());

      if (image?.name) {
        formdata.append("image", image);
      }

      if (types == "edit") {
        dispatch(saveLoader(true));
        setBtn(true);
        formdata.append("_method", "PUT");
        editApi({ id: location?.state?.data?.id, payload: formdata })
          .unwrap()
          .then((res) => {
            dispatch(saveLoader(false));
            setBtn(false);
            if (res?.status == "success") {
              Swal.fire({
                text: res?.message,
                icon: "success",
              });
              navigate("/hotel-category-list");
            }
          })
          .catch((err) => {
            dispatch(saveLoader(false));
            setBtn(false);
            console.log("err");
          });
      } else {
        dispatch(saveLoader(true));
        setBtn(true);
        addApi(formdata)
          .unwrap()
          .then((res) => {
            dispatch(saveLoader(false));
            setBtn(false);
            if (res?.status === "success") {
              Swal.fire({
                text: res?.message,
                icon: "success",
              });
              navigate("/hotel-category-list");
            }
          })
          .catch((err) => {
            dispatch(saveLoader(false));
            setBtn(false);
            console.error("Error", err);
          });
      }
    }
  };

  const getView = () => {
    dispatch(saveLoader(true));
    viewApi(location?.state?.data?.id)
      .unwrap()
      .then((res) => {
        dispatch(saveLoader(false));
        if (res?.status == "success" || res?.data?.status == "success") {
          let data = res?.category;

          if (data?.services?.length > 0) {
            let services_ = [];

            data?.services?.map((item, ind) => {
              services_.push(item?.service_type);
            });

            setService_type(services_);
          }

          if (data?.name) {
            setName(data?.name);
          }

          if (data?.image) {
            setImage(data?.image);
          }
        }
      })
      .catch((err) => {
        dispatch(saveLoader(false));
        console.log("err", err);
      });
  };

  const handleChange = (selectedItems) => {
    let flavors = [];
    for (let i = 0; i < selectedItems.length; i++) {
      flavors.push(selectedItems[i].value);
    }
    setService_type(flavors);
  };

  const getCreateCategory = () => {
    dispatch(saveLoader(true));
    categoryCreateApi()
      .unwrap()
      .then((res) => {
        dispatch(saveLoader(false));
      })
      .catch((err) => {
        dispatch(saveLoader(false));
        console.log("err", err);
      });
  };

  useEffect(() => {
    if (location?.state?.data?.id) {
      getView();
    }
    // getCreateCategory();
  }, []);

  return (
    <div className="dashRightView home_section">
      <TopHeader
        type={types == "edit" ? "edit-hotel-category" : "add-hotel-category"}
      />
      <div className="mt-4 block block-rounded ">
        <div className="block-content">
          <Row>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  Category Name
                </label>
                <input
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => setName(e.target.value)}
                  value={name}
                />
              </div>
              {name?.length == 0 && nameErr && (
                <p className="err">Enter Category Name</p>
              )}
            </div>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  Service Type
                </label>
                <select
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => handleChange(e.target.selectedOptions)}
                  value={service_type}
                  multiple={true}
                  size={4}
                >
                  <option value={""} disabled>
                    Select Service Type
                  </option>
                  <option value="just_walking">Just Walking </option>
                  <option value="day_outing">Day Outing </option>
                  <option value="room_booking">Room Booking </option>
                  <option value="room_sharing">Room Sharing </option>
                  <option value="get_together">Get To Gether </option>
                </select>
              </div>
              {service_type?.length == 0 && service_typeErr && (
                <p className="err">Select Service Type</p>
              )}
            </div>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  Image (307 X 207) pixel
                </label>
                <input
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => setImage(e.target.files[0])}
                  type={"file"}
                  accept="image/jpeg, image/png"
                />
              </div>
              {image?.length == 0 && imageErr && (
                <p className="err">Add Image</p>
              )}
            </div>

            {image && (
              <div className="col-md-6 mb-3">
                <div className="mt-3 mx-3">
                  <img
                    src={image?.name ? URL.createObjectURL(image) : image}
                    style={{ width: "200px" }}
                  />
                </div>
              </div>
            )}
          </Row>
          <Row>
            <div className="col-md-12 text-start mx-3 mt-4 mb-4">
              <button
                className={`submit-btn f2  ${btn ? "opacity-50" : ""}`}
                onClick={() => submitHandler()}
                disabled={btn}
              >
                Save
              </button>
            </div>
          </Row>
        </div>
      </div>
    </div>
  );
};
export default HotelCategory;
